import { LinearProgress } from '@mui/material';
import { FirmDailyNavCompanyConfigRow } from 'api';
import { Box, Stack, Text } from 'components/ui';
import { DAILY_NAV_SETUP_TEST_IDS } from '../DailyNavSetup.testIds';
import { CompanySetupStatus, companySetupStatus } from '../dailyNavSetup.utils';

type CompanyWalkthroughProgressProps = {
  companies: FirmDailyNavCompanyConfigRow[];
  activeCompanyId: number;
};

// Position in the walkthrough, plus how many companies are ready so far.
const CompanyWalkthroughProgress = ({ companies, activeCompanyId }: CompanyWalkthroughProgressProps) => {
  const position = companies.findIndex(row => row.company_id === activeCompanyId) + 1;
  const readyCount = companies.filter(row => companySetupStatus(row) === CompanySetupStatus.READY).length;

  return (
    <Box data-testid={DAILY_NAV_SETUP_TEST_IDS.companyProgress}>
      <Stack direction="row" justifyContent="space-between" sx={{ mb: 1 }}>
        <Text variant="body2">
          Company {position} of {companies.length}
        </Text>
        <Text variant="body2" color="text.secondary">
          {readyCount} ready
        </Text>
      </Stack>
      <LinearProgress
        variant="determinate"
        value={companies.length ? (position / companies.length) * 100 : 0}
        aria-label={`Company ${position} of ${companies.length}`}
      />
    </Box>
  );
};

export default CompanyWalkthroughProgress;
